import { authService } from './authService';

class EmailService {
  constructor() {
    this.sesConfigured = false;
  }

  /**
   * Get current user's email for sending notifications
   */
  async getCurrentUserEmail() {
    try {
      const result = await authService.getCurrentUserWithAttributes();
      if (result.success) {
        return result.user?.attributes?.email || null;
      }
      return null;
    } catch (error) {
      console.error('Failed to get user email:', error);
      return null;
    }
  }

  /**
   * Send email notification for historic data download
   */
  async sendHistoricDataNotification(requestData,backendApiPrefix) {
    try {
      const userEmail = await this.getCurrentUserEmail();
      
      if (!userEmail) {
        throw new Error('User email not available');
      }

      // Prepare email data
      const emailData = {
        ...requestData,
        recipientEmail: userEmail,
        emailType: 'historic_data_download'
      };

      // Make API call to backend with email data
      const response = await fetch(backendApiPrefix+'/api/send-historic-metric-data-by-email/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(emailData)
      });

      if (!response.ok) {
        throw new Error(`Email service error: ${response.statusText}`);
      }

      const result = await response.json();
      return {
        success: true,
        message: 'Email notification will be sent when data is ready',
        data: result
      };

    } catch (error) {
      console.error('Email service error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Create email template for historic data download
   */
  generateEmailTemplate(downloadData) {
    const { airport, metrics, downloadLink, fileName } = downloadData;
    
    return {
      subject: `SWANS Historic Data Ready - ${airport}`,
      htmlBody: `
        <!DOCTYPE html>
        <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
            .container { max-width: 600px; margin: 0 auto; padding: 20px; }
            .header { background: linear-gradient(135deg, #275AA6 0%, #1e4a8c 100%); color: white; padding: 20px; border-radius: 8px 8px 0 0; }
            .content { background: #f9f9f9; padding: 20px; border-radius: 0 0 8px 8px; }
            .download-btn { background: #275AA6; color: white; padding: 12px 24px; text-decoration: none; border-radius: 4px; display: inline-block; margin: 20px 0; }
            .metrics-list { background: white; padding: 15px; border-radius: 4px; margin: 15px 0; }
            .footer { text-align: center; margin-top: 20px; font-size: 12px; color: #666; }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <h2>🛩️ SWANS Historic Data Ready</h2>
              <p>Your requested aviation safety data for ${airport} is ready for download</p>
            </div>
            
            <div class="content">
              <h3>Download Details:</h3>
              <div class="metrics-list">
                <strong>Airport:</strong> ${airport}<br>
                <strong>Metrics:</strong> ${metrics.map(m => m.title).join(', ')}<br>
                <strong>File:</strong> ${fileName}
              </div>
              
              <a href="${downloadLink}" class="download-btn">Download Your Data</a>
              
              <p><strong>Note:</strong> This download link will expire in 7 days for security purposes.</p>
              
              <h4>Need Help?</h4>
              <p>If you have any questions about this data or need assistance, please contact our support team.</p>
            </div>
            
            <div class="footer">
              <p>This email was sent from the SWANS Aviation Safety Monitor system.<br>
              Please do not reply to this automated email.</p>
            </div>
          </div>
        </body>
        </html>
      `,
      textBody: `
        SWANS Historic Data Ready - ${airport}
        
        Your requested aviation safety data for ${airport} is ready for download.
        
        Download Details:
        - Airport: ${airport}
        - Metrics: ${metrics.map(m => m.title).join(', ')}
        - File: ${fileName}
        
        Download Link: ${downloadLink}
        
        Note: This download link will expire in 7 days for security purposes.
        
        If you have any questions, please contact our support team.
        
        This is an automated email from the SWANS Aviation Safety Monitor system.
      `
    };
  }
}

export default new EmailService();